import { ButtonBase, makeStyles } from '@material-ui/core';
import { map } from 'lodash';
import React from 'react';

const useItemStyle = makeStyles((theme) => ({
  root: {
    background: ({ isActivated }) => (isActivated ? theme.palette.primary.main : 'transparent'),
    fontSize: 12,
    padding: theme.spacing(1),
    flexShrink: 0,
  },
}));

function Item({ data, onClick }) {
  const { label, isActivated } = data || {};
  const classes = useItemStyle({ isActivated });

  return (
    <ButtonBase className={classes.root} onClick={() => onClick(data)}>
      {label}
    </ButtonBase>
  );
}

const useStyle = makeStyles((theme) => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    overflowX: 'auto',
    marginTop: theme.spacing(1),
    padding: theme.spacing(0, 2),
  },
}));

export default function DateFilter({ data, onItemClick }) {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      {map(data, (item) => {
        const { value } = item;

        return (
          <Item data={item} key={value} onClick={onItemClick} />
        );
      })}
    </div>
  );
}
